/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NfcRequest
 */
export interface NfcRequest {
    /**
     * 
     * @type {string}
     * @memberof NfcRequest
     */
    id?: string;
}

/**
 * Check if a given object implements the NfcRequest interface.
 */
export function instanceOfNfcRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NfcRequestFromJSON(json: any): NfcRequest {
    return NfcRequestFromJSONTyped(json, false);
}

export function NfcRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NfcRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function NfcRequestToJSON(value?: NfcRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

